import PropTypes from 'prop-types';

export const data = PropTypes.shape({
    amount: PropTypes.number,
    automaticApprove: PropTypes.string,
    discount: PropTypes.number,
    fee: PropTypes.number,
    performedBy: PropTypes.oneOf(['BACKOFFICE', 'BUYER', 'SELLER', 'SYSTEM']),
    receiptUrl: PropTypes.string,
    spidWalletUrl: PropTypes.string,
    withdrawFlowSpidUrl: PropTypes.string,
});

export default PropTypes.shape({
    data,
    error: PropTypes.bool,
    loading: PropTypes.bool,
});



// WEBPACK FOOTER //
// ./safeTrade/paymentPropTypes.js